import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Title } from 'components';

/**
 * CardTitle component for displaying a card header/title.
 * @param {*} props - The props for CardTitle.
 * @param {React.ReactNode} [props.title] - The title to display. If not provided, children will be used.
 * @param {object} [props.style] - Optional style overrides for the Typography component.
 * @param {React.ReactNode} [props.children] - Optional children to display instead of title.
 */
const CardTitle = ({ title, style, children }) => {
  const theme = useTheme();
  return (
    <>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: '10px'
      }}>

        <span style={{
          color: 'purple',
          fontSize: '16px',
          whiteSpace: 'nowrap'
        }}>
          <Title title={title || children} style={style} />
        </span>
       <div className='w-full flex items-center pl-2'>
          <div style={{ width: '100%', height: 1.3, background: `linear-gradient(80deg, ${theme.palette.primary.main} 30%,  ${theme.palette.primary.dark}  60%)`, borderRadius: 2 }} className="main-title-underline"></div>
        </div>
      </div>
    
    </>
  );
};

CardTitle.propTypes = {
  style: PropTypes.object,
  title: PropTypes.node,
  children: PropTypes.node,
};

CardTitle.defaultProps = {
  title: null,
  style: null,
};

export default CardTitle; 